import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NoticeType } from "root/components/noticebar/noticebar.enum";
import { FrontendContextService, LoaderService, LogService, MibpLogger, NoticebarService } from "root/services";
import { firstValueFrom } from "rxjs";

import { LoaderComponent } from 'root/shared/components/status/loader/loader.component';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { ordersFnGetExternalLinkOrder } from "root/mibp-openapi-gen/fn/orders/orders-fn-get-external-link-order";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

@Component({
  templateUrl: './redirect-order-page.component.html',
  styleUrls: ['./redirect-order-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoaderComponent, ResourceStringComponent]
})
export class RedirectOrderPageComponent implements OnInit {
    private mibpApiService = inject(MibpApiService);
  private loader = inject(LoaderService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private context = inject(FrontendContextService);
  private notificationService = inject(NoticebarService);
  private log = inject(LogService).withPrefix('redirect-order-page');

  mdgBusinessRelationId:string;
  orderNumber:string;
  isNotFound: boolean;
  isActingAs: boolean;


  ngOnInit(): void {


    void this.initializeComponent();


  }



  private async initializeComponent(): Promise<void> {
    this.loader.showFullScreenLoader();
    this.mdgBusinessRelationId = this.route.snapshot.queryParams.mdgBusinessRelationId;
    this.orderNumber = this.route.snapshot.queryParams.orderNumber;

    try{
      const result = await firstValueFrom(this.mibpApiService.invoke(ordersFnGetExternalLinkOrder, { mdgBusinessRelationId: this.mdgBusinessRelationId,orderNumber: this.orderNumber}));
      this.loader.hideFullScreenLoader();
      this.isNotFound = false;
      const orderTypeText= result.orderType ===0?"/shop/orders":"/shop/quotations";
      const orderTypeRouteText= orderTypeText.concat("/"+result.id);
      const url = this.context.Navigation.ensureUrlLanguage(orderTypeRouteText);
      this.router.navigateByUrl(url);
    }catch (ex) {
      this.isNotFound = true;
      this.loader.hideFullScreenLoader();
      this.log.error('Could not fetch order details' ,ex);
      this.notificationService.showText('Could not fetch order details', NoticeType.Error, false);
    }
  }
}
